import React from 'react';
import { CircularProgress } from '@mui/material';
import { styled } from '@mui/material/styles';

const LoadingDiv = styled('div')(() => ({
  width: '100%',
  height: '100%',
  position: 'absolute',
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  background: 'gray',
  zIndex: 99999,
  opacity: 0.5,
}));

function Loading() {
  return (
    <LoadingDiv>
      <CircularProgress
        color="inherit"
        sx={{
          position: 'absolute',
          margin: 'auto',
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
        }}
      />
    </LoadingDiv>
  );
}

export default Loading;
